import React, { Component } from 'react';
import { Row, Col } from 'antd';

import { events } from 'constants/routes';
import { defaultEventListFilters } from 'constants/defaultFilters';
import { getStatusPayload } from 'helpers/filterHelpers';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { TabsStatusFilter } from 'components/common/controls/TabsStatusFilter';
import RefreshButton from 'components/common/controls/RefreshButton';
import StaticTable from 'components/common/tableComponents/StaticTable';
import ActionListTable from './ActionListTable';
import CoursesListTable from './CoursesListTable';

@withRouteOptions
export default class ActionListView extends Component {
    static routeOptions = {
        title: 'menu.events'
    }

    renderTable = ({ meta, refresh, columns, data }) => {
        return (
            <div>
                <Row className="react-table-controls list-controls">
                    <Col span={18}>
                        <TabsStatusFilter
                            key='tabs'
                            route={events}
                            defaultFilters={defaultEventListFilters}
                            translate='events'
                        />
                    </Col>
                    <Col span={6} className="text-right icon-bar">
                        <RefreshButton refreshMeta={meta} handleRefresh={refresh} />
                    </Col>
                </Row>
                <div>
                    <StaticTable
                        meta={meta}
                        refresh={refresh}
                        className="width-auto-table"
                        columns={columns}
                        items={data}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { status } = getStatusPayload(this.props);
        const TableView = status === 'actions' ? ActionListTable : CoursesListTable;

        return (
            <TableView renderTable={this.renderTable} />
        );
    }
}
